<template>
  <!-- Table Container Card -->
  <b-card>

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />

          <Button
            v-if="getUserPermission('CREATE_APPROVAL_SETUP')"
            label="Add New configuration"
            size="md"
            @click="goToApprovalSetup"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              label="Filter"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              label="Reset Filter"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="configurationRef"
      :busy="isBusy"
      :per-page="perPage"
      :current-page="currentPage"
      :items="configuredApprovalSetup"
      responsive
      :fields="tableHeaders"
      primary-key="name"
      show-empty
      empty-text="No records available"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_APPROVAL_SETUP')"
              @click="goToEditApprovalSetup(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Modify</span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectItem(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item @click="onDeleteApprovalSetup(data.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete Approval Setup</span>
            </b-dropdown-item>

          </b-dropdown>
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="configurationModalRef"
      ok-title="Cancel"
      ok-only
      ok-variant="outline-secondary"
      centered
      size="xl"
      :title="modalTitle"
      @hidden="resetModal"
    >
      <div class="mb-2 mt-3 d-flex align-items-center">
        <TableEntries
          v-model="userPerPage"
          :options="perPageOptions"
        />
      </div>

      <b-table
        ref="configurationTableRef"
        :per-page="userPerPage"
        :current-page="userCurrentPage"
        :items="userMappings"
        responsive
        :fields="configurationTableHeaders"
        primary-key="userId"
        show-empty
        empty-text="No records available"
        class="position-relative"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              class="align-middle"
              variant="primary"
            />
          </div>
        </template>
        <template #cell(SN)="data">
          {{ getTableNumber(data.index) }}
        </template>
      </b-table>

      <TablePagination
        v-model="userCurrentPage"
        :from="userFrom"
        :to="userTo"
        :total-rows="userTotalEntries"
        :per-page="userPerPage"
      />

      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      ok-title="Apply"
      no-close-on-backdrop
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      centered
      size="lg"
      title="Filters"
      modal-footer
      @ok="filterApprovalSetup"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Function Name -->
        <b-col md="6">
          <SelectField
            id="function-name"
            v-model="filter.functionName"
            label="Function Name"
            :options="functionNameOptions"
            :reduce="option => option"
            error-name="Function Name"
            rules="required"
            item="label"
            placeholder="Select Function Name"
          />
        </b-col>
        <!-- Function Name -->

        <!-- No of Approval Levels -->
        <b-col md="6">
          <InputField
            id="staff-id"
            v-model="filter.noOfApprovals"
            label="No of Approval Levels"
            placeholder="Enter No of Approval Levels"
            type="number"
          />
        </b-col>
        <!-- No of Approval Levels -->

        <!-- Date Modified -->
        <!-- <b-col md="6">
          <DatePickerField
            id="date-of-birth"
            v-model="filter.dateModified"
            rules="required"
            label="Last Date Modified"
            format="Y-m-d"
            :config="datePickerConfig"
          />
        </b-col> -->
        <!-- Date Modified -->

        <!-- Last Modified By -->
        <!-- <b-col md="6">
          <InputField
            id="staff-id"
            v-model="filter.modifiedBy"
            label="Last Modified By"
            placeholder="Enter last modified by"
            type="number"
          />
        </b-col> -->
        <!-- Last Modified By -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BModal, BDropdown, BDropdownItem, VBTooltip,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { required, minPhoneVal, maxPhoneVal } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { permissionMixin } from '@core/mixins/permission'
import { heightTransition } from '@core/mixins/ui/transition'
import { toBalance } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toMonthWithTime } from '@/helpers/formatDate'
import { operationPermissions } from '@/helpers/permissions'
import Button from '../../../components/button/Button.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
// import DatePickerField from '../../../forms/DatePickerField.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BDropdown,
    BDropdownItem,
    TablePagination,
    BModal,
    BSpinner,
    TableEntries,
    SelectField,
    InputField,
    Button,
    FullScreenSpinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin, heightTransition],
  data() {
    return {
      datePickerConfig: {
        dateFormat: 'd/m/Y',
      },
      isReadonly: false,
      isEditable: false,
      isFullName: false,
      showSpinner: false,
      sortBy: 'name',
      required,
      minPhoneVal,
      maxPhoneVal,
      modalTitle: 'Create Account Officer',
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'name', sortable: true, label: 'Function name' },
        // { key: 'groupName', sortable: true },
        { key: 'noOfApprovalStages', sortable: true, label: 'No Of Approval Levels' },
        { key: 'minAmount', sortable: true, label: 'Min. Approval Amount' },
        { key: 'maxAmount', sortable: true, label: 'Max. Approval Amount' },
        { key: 'dateLastModified', sortable: true, label: 'Last Modified Date' },
        // { key: 'lastModifiedBy', sortable: true },
        { key: 'actions' },
      ],
      configurationTableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'id', sortable: true, label: 'User ID' },
        { key: 'fullName', sortable: true },
        { key: 'branch', sortable: true },
        { key: 'scopeLimit', sortable: true, label: 'User Scope' },
        { key: 'level', sortable: true },
        { key: 'minAmount', sortable: true, label: 'Min. Approval Amount' },
        { key: 'maxAmount', sortable: true, label: 'Max. Approval Amount' },
      ],
      userMappings: [],
      userTotalCount: 0,
      userOptions: [],
      filter: {
        functionName: '',
        noOfApprovals: '',
        dateModified: '',
        modifiedBy: '',
        sortColumn: '',
        PostingType: '',
        PostingReference: '',
      },
      functionNameOptions: [],
      configuredApprovalSetup: [],
      configuredApprovalItems: [],
      configuredApprovals: [],
      userCurrentPage: 1,
      userPerPage: 10,
    }
  },
  computed: {
    userTotalEntries() {
      return this.userTotalCount
    },
    userFrom() {
      return (this.userCurrentPage * this.userPerPage) - (this.userPerPage - 1)
    },

    userTo() {
      return Math.min(this.userFrom + this.userPerPage - 1, this.userTotalEntries)
    },
    totalEntries() {
      return this.configuredApprovalSetup.length
    },
    from() {
      return (this.currentPage * this.perPage) - (this.perPage - 1)
    },

    to() {
      return Math.min(this.from + this.perPage - 1, this.totalEntries)
    },
  },
  mounted() {
    this.fetchConfigurations()
  },
  methods: {
    ...mapActions({
      createApprovalConfiguration: 'operations/createApprovalConfiguration',
      getApprovalConfiguration: 'operations/getApprovalConfiguration',
      getApprovalConfigurations: 'operations/getApprovalConfigurations',
      deleteApprovalConfiguration: 'operations/deleteApprovalConfiguration',
    }),
    goToApprovalSetup() {
      this.$router.push({
        name: 'approval-setup',
        params: {
          type: 'postings',
        },
      }).catch(error => {
        this.alertError({ text: error })
      })
    },
    getTableNumber(index) {
      return (this.userCurrentPage * this.userPerPage) - this.userPerPage + index + 1
    },
    goToEditApprovalSetup(item) {
      this.$router.push({
        name: 'approval-setup',
        params: {
          id: item.permission.id,
          type: 'postings',
        },
      }).catch(error => {
        this.alertError({ text: error })
      })
    },
    async fetchConfigurations() {
      try {
        this.isBusy = true
        const response = await this.getApprovalConfigurations({ permission: operationPermissions.VIEW_POSTING_APPROVAL })
        const { status, data } = response

        if (status === 200 && data.data) {
          const filteredItems = data.data.filter(item => item.permission !== null && item.permission.isPostingsPermission).map(item => {
            const minAmount = []
            const maxAmount = []
            item.userMappings.forEach(items => minAmount.push(items.minAmount))
            item.userMappings.forEach(items => maxAmount.push(items.maxAmount))
            return {
              ...item,
              name: item.permission.description,
              groupName: item.permission.groupName,
              dateLastModified: toMonthWithTime(item.dateLastModified),
              minAmount: toBalance(Math.min(...minAmount)),
              maxAmount: toBalance(Math.max(...maxAmount)),
            }
          })

          this.functionNameOptions = filteredItems.map(item => item.name)
          this.configuredApprovalSetup = filteredItems
          this.configuredApprovalItems = filteredItems
          this.configuredApprovals = filteredItems
          // this.isBusy = false
        } else {
          this.configuredApprovalSetup = []
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },
    filterApprovalSetup() {
      this.configuredApprovals = this.configuredApprovalItems
      if (this.filter.functionName !== '' || this.filter.noOfApprovals !== '') {
        const items = this.configuredApprovals.filter(item => item.name === this.filter.functionName || item.noOfApprovalStages === Number(this.filter.noOfApprovals))
        // eslint-disable-next-line no-return-assign
        return this.configuredApprovalSetup = items
      }
      // eslint-disable-next-line no-return-assign
      return this.configuredApprovalSetup = this.configuredApprovalItems
    },
    async onSelectItem(items) {
      try {
        this.showSpinner = true
        const response = await this.getApprovalConfiguration({ id: items.permission.id })
        const { status, data } = response
        if (status === 200 && data.userMappings.length) {
          this.userMappings = data.userMappings.map(item => {
            let fullName
            let id
            let scopeLimit
            let branch
            if (item.user !== null) {
              fullName = `${item.user.lastname} ${item.user.firstname} ${item.user.othernames}`
              id = item.user.username
              branch = item.user.branch
              scopeLimit = item.user.scopeLimit
            }
            return {
              ...item,
              fullName,
              id,
              scopeLimit,
              branch,
              level: item.level,
              minAmount: toBalance(item.minAmount),
              maxAmount: toBalance(item.maxAmount),
            }
          }).sort((a, b) => a.level - b.level)
          this.userTotalCount = data.userMappings.length
        }

        this.showSpinner = false
        this.modalTitle = items.name
        this.$root.$emit('bv::show::modal', 'modal-lg')
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },

    async onDeleteApprovalSetup(item) {
      try {
        const deleteApprovalSetup = async () => {
          this.showSpinner = true
          const response = await this.deleteApprovalConfiguration(item.permission.id)
          const { status } = response
          if (status === 200) {
            this.fetchConfigurations()
            this.alertSuccess({ text: 'Your request to delete approval setup was successful' })
            this.showSpinner = false
          }
        }
        this.confirm(deleteApprovalSetup, { title: '', text: 'Are you sure you want to delete this approval setup?' })
      } catch (error) {
        this.handleError(error)
      } finally {
        this.showSpinner = false
      }
    },

    resetModal() {
      this.userMappings = []

      this.isLoading = false
      this.isEditable = false
      this.isReadonly = false
      this.buttonLabel = 'Save'
      this.modalTitle = ''
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchConfigurations()
    },
  },
}
</script>
